import { decodeHexResponse } from '../_common/common.utils';
import LeaveAdjustmentTypes from './LeaveAdjustment.types';

const INITIAL_STATE = {
	employeeLeaveBalance: null,
	createLeaveAdjustment: null,
	employeeApprovedLeavesForYear: null,
	updateAppliedLeaveResponse: null,
	leaveEditHistory: null,
};

const leaveAdjustmentReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		// GET EMPLOYEE LEAVE BALANCE REDUCER
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START:
			return { ...state, employeeLeaveBalance: null };
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS:
			return {
				...state,
				employeeLeaveBalance: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_KEY,
				),
			};
		case LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_FAILURE:
			return {
				...state,
				employeeLeaveBalance: { status: 'error', message: action.payload },
			};

		// CREATE LEAVE ADJUSTMENT REDUCER
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START:
			return { ...state, createLeaveAdjustment: null };
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_SUCCESS:
			return {
				...state,
				createLeaveAdjustment: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_KEY,
				),
			};
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_FAILURE:
			return {
				...state,
				createLeaveAdjustment: { status: 'error', message: action.payload },
			};
		case LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET:
			return {
				...state,
				createLeaveAdjustment: null,
			};

		// GET EMPLOYEE APPROVED LEAVES FOR YEAR
		case LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_START:
			return { ...state, employeeApprovedLeavesForYear: null };
		case LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_SUCCESS:
			return {
				...state,
				employeeApprovedLeavesForYear: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_KEY,
				),
			};
		case LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_FAILURE:
			return {
				...state,
				employeeApprovedLeavesForYear: { status: 'error', message: action.payload },
			};

		// UPDATE APPLIED LEAVE
		case LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_START:
			return { ...state, updateAppliedLeaveResponse: null };
		case LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_SUCCESS:
			return {
				...state,
				updateAppliedLeaveResponse: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_KEY,
				),
			};
		case LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_FAILURE:
			return {
				...state,
				updateAppliedLeaveResponse: { status: 'error', message: action.payload },
			};
		case LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_RESPONSE_RESET:
			return { ...state, updateAppliedLeaveResponse: null };

		// GET LEAVE EDIT HISTORY
		case LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_START:
			return { ...state, leaveEditHistory: null };
		case LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_SUCCESS:
			return {
				...state,
				leaveEditHistory: decodeHexResponse(
					action.payload,
					LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_KEY,
				),
			};
		case LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_FAILURE:
			return {
				...state,
				leaveEditHistory: { status: 'error', message: action.payload },
			};

		case LeaveAdjustmentTypes.LEAVE_ADJUSTMENT_PAGE_RESET:
			return {
				...INITIAL_STATE,
			};

		default:
			return state;
	}
};

export default leaveAdjustmentReducer;

